export default {"src":"/_next/static/media/twisp-logo-black.00865336.svg","height":358,"width":1390};